/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Translate, Translator } from 'react-translated';
import { setHasChanges } from '../../../store/actions/globalMessagesActions';
import { Row, Col, Nav, Navbar, NavItem, Form, Button } from 'react-bootstrap';
import { messagesTableActions } from '../../../store/actions/messagesTableActions';
import RichTextEditor from './RichTextEditor';
function AddEditMessages(props) {
    const {
        handleCloseForm,
        result,
        setData,
        data
    } = props;

    const {
        INPUT_MAX_LENGTH,
        DESCRIPTION_MAX_LENGTH
    } = require('../../../config/constants');
    const dispatch = useDispatch();

    // State data.
    const hasChanges = useSelector(state => state.hasChanges);

    const [validated, setValidated] = useState(false);
    const formSubmitRef = useRef(null);
    const {
        headline,
        body,
        audience,
        changeType,
        enabled,
        id
    } = data
    // Result changes
    useEffect(() => {
        if (result && typeof result === 'object') {
            setData(data => ({...data, ...result}));
        } else {
            handleCloseForm();
        }
    }, [result]);

    const checkChanges = () => {
        if (!hasChanges) {
            dispatch(setHasChanges(true));
        }
    };

    const handleChange = (event, isNumeric, trim) => {
        const { name, value } = event.target;
        let val;

        if (isNumeric) {
            if (value) {
                val = parseInt(value, 10);
            } else {
                val = null;
            }
        } else if (value) {
            if (trim) {
                val = value.replace(/\s/g, '');
            } else {
                val = value;
            }
        } else {
            val = '';
        }
            setData(data => ({...data, [name]: val }));

        checkChanges();
    };

    const handleSubmit = async (event) => {
        event.currentTarget.blur();
		event.preventDefault();
		event.stopPropagation();

		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.preventDefault();
			event.stopPropagation();
			setValidated(true);
			return;
		}

		setValidated(true);
        let payload = { ...data };
        payload.changeType = 'SAVE';
        if (typeof data.body !== 'string') {
            payload.body = JSON.stringify(data.body);
        } else {
            payload.body = data.body;
        }
        dispatch(messagesTableActions.updateMessageTable('adminmessage', payload, 'messages'));
        handleCloseForm();
    };

    const handleClose = () => {
        handleCloseForm();
    };

    return (
        <div className={'box box--blue-light box--wide'}>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Row className="align-items-center">
                    <Col md={7}>
                        <h2 className="mb-2"><Translate text={(result && result.id) ? 'Edit Message' : 'Add Message'} /></h2>
                    </Col>
                    <Col md={5}>
                        <Navbar className={'form-nav justify-content-end'}>
                            <Nav>
                                <NavItem>
                                    <Button variant="primary" onClick={() => handleClose()}>
                                        <Translate text={'Cancel'}/>
                                    </Button>
                                </NavItem>

                                <NavItem>
                                    <Button variant="primary" type="submit" ref={formSubmitRef} onClick={() => {
                                        setData(data => ({...data, enabled: false }));
                                    }}>
                                        <Translate text={'Save as Draft'}/>
                                    </Button>
                                </NavItem>

                                <NavItem>
                                    <Button variant="success" type="submit" ref={formSubmitRef} onClick={() => {
                                        setData(data => ({...data, enabled: true }));
                                    }}>
                                        <Translate text={'Publish'}/>
                                    </Button>
                                </NavItem>
                            </Nav>
                        </Navbar>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <Form.Group controlId="message-headline">
                            <Form.Label>
                                <Translate text={'Headline'} /> <span className="required">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="headline"
                                value={ headline }
                                maxLength={ INPUT_MAX_LENGTH }
                                required
                                onChange={(e) => { handleChange(e); }}
                            />
                            {/* <Form.Control.Feedback type="invalid">
                                <Translate
                                    text={'{formLabel} is required'}
                                    data={{
                                        formLabel: 'Contact Information'
                                    }}
                                />
                            </Form.Control.Feedback> */}
                        </Form.Group>
                            <Form.Group controlId="description">
                                <Form.Label className="max-width-none">
                                   <Translate text={'Body'} />
                                </Form.Label>
                                {/* <Form.Control
                                    as="textarea"
                                    name="body"
                                    value={body}
                                    maxLength={DESCRIPTION_MAX_LENGTH}
                                    onChange={(e) => { handleChange(e); }}
                            /> */}
                                <RichTextEditor
                                    value={body}
                                    onChange={(htmlContent) => {
                                        // Create a synthetic event to match your existing handleChange function
                                        const syntheticEvent = {
                                            target: {
                                                name: 'body',
                                                value: htmlContent
                                            }
                                        };
                                        console.log('syntheticEvent', syntheticEvent);
                                        handleChange(syntheticEvent);
                                    }}
                                    maxLength={DESCRIPTION_MAX_LENGTH}
                                />
                        </Form.Group>
                        <Form.Group role="group">
                            <Form.Label>
                            <Translate text={'Audience'} /> <span className="required">*</span>
                            </Form.Label>
                            <Form.Check
                                label="Everyone"
                                name="audience"
                                id="everyone"
                                className="form-check-big"
                                type="radio"
                                required
                                value="EVERYONE"
                                checked={audience === 'EVERYONE'}
                                onChange={handleChange}
                                onInvalid={(e) => e.target.closest('.form-group').classList.add('is-invalid')}
                            />
                            <Form.Check
                                label="PSE"
                                name="audience"
                                id="PSE"
                                className="form-check-big"
                                type="radio"
                                required
                                value="PSE"
                                checked={audience === 'PSE'}
                                onChange={handleChange}
                                onInvalid={(e) => e.target.closest('.form-group').classList.add('is-invalid')}
                            />
                            <Form.Check
                                label="Suppliers"
                                name="audience"
                                id="Suppliers"
                                className="form-check-big"
                                type="radio"
                                required
                                value="SUPPLIER"
                                checked={audience === 'SUPPLIER'}
                                onChange={handleChange}
                                onInvalid={(e) => e.target.closest('.form-group').classList.add('is-invalid')}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
export default AddEditMessages;
